<template>
	<div class="element-wrapper text-left">
		<div class="element-box-tp">
			<div class="alert alert-success" v-if="status == 200">
				{{ t.form.success }}
			</div>
			<div class="alert alert-danger" v-if="status == 401">
				{{ t.error.access_denied_content }}
			</div>
			<div class="alert alert-danger" v-if="status == 404">
				{{ t.error.notfound_content_list }}
			</div>
			<filterGenerator :filter="filter"></filterGenerator>
		</div>
	</div>
</template>

<script>
    import filterGenerator from '@/components/form/filter'
    export default {
        components: {filterGenerator},
        name: 'referrer',
	    props:{
            uid: {
                type: Number,
	            default: 0
            }
	    },
        data () {
            return {
                t: this.$root.t,
                filter: null,
	            referrer: [],
                filter: null,
                status: 0
            }
        },
	    mounted () {
            this.fetchAffiliateSettings()
	    },
	    methods: {
            setFilter () {
                this.filter = {
                    model: {
                        referrer: 0,
                        commissionRate: 0
                    },
                    schema: {
                        groups: [
                            {
                                legend: '',
                                fields: [
                                    {
                                        type: "User",
                                        inputType: "text",
                                        label: this.t.referrer,
                                        model: "referrer",
                                        multi: false,
	                                    data: this.referrer,
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: this.t.commission_percent,
                                        model: "commissionRate",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "submit",
                                        label: "",
                                        buttonText: this.t.update,
                                        onSubmit: this.setAffiliateSettings,
                                        validateBeforeSubmit: false,
                                    }
                                ]
                            }
                        ],
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }


            },
		    resetStatus () {
                setTimeout( () => {
                    this.status = 0
                },3000)
		    },
		    fetchReferrer () {

                this.$http.get(api+'api/v1/affiliate/user/referrer/'+this.uid).then(response => {
                    // get body data
                    this.type = response.body.result.type;
	                this.isLoading = false;
                    this.referrer = response.body.result;
                    this.setFilter()
                    this.filter.model.ref = response.body.result[0].id;

                }, response => {
                    this.isLoading = false;
                    this.setFilter()
                })
		    },
		    fetchAffiliateSettings () {

                this.$http.get(api+'api/v1/affiliate/settings/'+this.uid).then(response => {
                    // get body data
	                this.isLoading = false;
	                this.referrer = response.body.result;
                    this.fetchReferrer();
                    this.filter.model.commissionRate = response.body.result.data.commission_rate;
                    this.filter.model.referrer = response.body.result.data.referrer;

                }, response => {

                    this.isLoading = false;
                    this.fetchReferrer();
                    this.filter.model.commissionRate = response.body.result.data.commission_rate;
                    this.filter.model.referrer = response.body.result.data.referrer;
                })
		    },
            setAffiliateSettings () {

	            this.$http.post(api+'api/v1/affiliate/settings/'+this.uid, this.filter.model).then(response => {
	                    // get body data
		            this.isLoading = false;
	                this.status = response.status;
	                this.referrer = response.body.result;
	                this.fetchReferrer();
	                this.resetStatus();
	            }, response => {

                    this.isLoading = false;
                    this.status = response.status;
                    this.fetchReferrer();
                    this.resetStatus();

	           })


            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/referrer.vue